import { render, staticRenderFns } from "./add-bank-card.vue?vue&type=template&id=01f39f2c&scoped=true&"
import script from "./add-bank-card.vue?vue&type=script&lang=js&"
export * from "./add-bank-card.vue?vue&type=script&lang=js&"
import style0 from "./add-bank-card.vue?vue&type=style&index=0&id=01f39f2c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f39f2c",
  null
  
)

export default component.exports